module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero-home"
  }, [_c('div', {
    staticClass: "hero-home__desktop"
  }, [_c('swiper', {
    staticClass: "hero-home__slider",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_c('swiperSlide', {
    staticClass: "hero-home__slide"
  }, [_c('div', {
    staticClass: "hero-home__image",
    staticStyle: {
      "background-image": "url(static/hero-home.jpg)"
    }
  })]), _c('swiperSlide', {
    staticClass: "hero-home__slide"
  }, [_c('div', {
    staticClass: "hero-home__image",
    staticStyle: {
      "background-image": "url(static/hero-home2.jpg)"
    }
  })]), _c('swiperSlide', {
    staticClass: "hero-home__slide"
  }, [_c('div', {
    staticClass: "hero-home__image",
    staticStyle: {
      "background-image": "url(static/hero-home3.jpg)"
    }
  })])], 1)], 1), _vm._m(0), _c('div', {
    staticClass: "hero-home__container"
  }, [_c('div', {
    directives: [{
      name: "waypoint",
      rawName: "v-waypoint",
      value: ({
        active: true,
        callback: _vm.scrolled
      }),
      expression: "{ active: true, callback: scrolled}"
    }],
    staticClass: "hero-home__waypoint"
  }), _c('div', {
    directives: [{
      name: "waypoint",
      rawName: "v-waypoint",
      value: ({
        active: true,
        callback: _vm.onWaypointTitle,
        options: _vm.intersectionTitleOptions
      }),
      expression: "{ active: true, callback: onWaypointTitle, options: intersectionTitleOptions }"
    }],
    staticClass: "hero-home__title",
    class: {
      "hero-home__title--active": _vm.fadeTitle
    }
  }, [_vm._v("Smile Bright, Shine Brighter"), _c('br'), _vm._v("HOW WOULD A NEW SMILE CHANGE YOUR LIFE?")]), _c('a', {
    staticClass: "hero-home__button",
    on: {
      "click": function($event) {
        _vm.showComplimentaryModal = true
      }
    }
  }, [_vm._v("BEGIN YOUR SMILE JOURNEY HERE")])]), _c('transition', {
    attrs: {
      "name": "fade-in-modal"
    }
  }, [_c('ComplimentaryExamForm', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showComplimentaryModal),
      expression: "showComplimentaryModal"
    }],
    on: {
      "closeComplimentaryModal": function($event) {
        _vm.showComplimentaryModal = false
      }
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero-home__mobile"
  }, [_c('div', {
    staticClass: "hero-home__slider"
  }, [_c('div', {
    staticClass: "hero-home__image",
    staticStyle: {
      "background-image": "url(static/hero-home.jpg)"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-752f6aef","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/hero/hero-home/hero-home.pug
// module id = 587
// module chunks = 1